import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";

import Sync from "Administrator/routes/SchoolSetup/routes/Sync";
import LTISettings from "SchoolSetup/routes/LTISettings";
import TurnItInSettings from "Administrator/routes/Settings/routes/TurnItInSettings";
import TimetableSync from "SchoolSetup/routes/TimetableSync";
import AttendanceSync from "SchoolSetup/routes/AttendanceSync";
import GradebookSync from "SchoolSetup/routes/GradebookSync";
import AssessmentSync from "SchoolSetup/routes/AssessmentSync";
import IntegrationInternalTool from "SchoolSetup/routes/IntegrationsInternalTools";
import SyncV2 from "SchoolSetup/routes/SyncV2";
import OpenApiSetup from "SchoolSetup/routes/OpenApiSetup";

export default store => ({
  path: "integrations",
  component: withAsyncRouteLoading(() =>
    Promise.all([import("./components")]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [
    Sync(store),
    SyncV2(store),
    LTISettings(store),
    TurnItInSettings(store),
    TimetableSync(store),
    AttendanceSync(store),
    GradebookSync(store),
    AssessmentSync(store),
    IntegrationInternalTool(store),
    OpenApiSetup(store),
  ],
});
